export enum LockOverlayVariant {
  Card = 'card',
  Page = 'page'
}

